import {type FunctionalComponent, h} from '@stencil/core';


interface SeeMoreProps{
    enabled:boolean,
    clickHandler: CallableFunction,
    text: string
}

export const SeeMoreLinks:FunctionalComponent<SeeMoreProps> = (props)=>{
    const {enabled, clickHandler, text} = props;
    if(!enabled)
      return '';

    return <div class="guided-pane__see-all-results-item">
      <span class="guided-pane__see-all-results-link">
        <qds-standalone-link
          class="guided-pane__see-all-results-link-text"
          onClick={e => clickHandler(e)}
          onKeyDown={(e) => clickHandler(e)}
        >
          {text}
        </qds-standalone-link>
        <se-icon 
          size="small" 
          class="guided-pane__see-all-results-link-icon" 
          onClick={e => clickHandler(e)}
        >arrow2_right</se-icon>
      </span>
    </div>;
};
